import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './ProgrammableLogicController.frontend.types'

@Injectable({ providedIn: 'root' })
export class ProgrammableLogicController_insert_connector_mapping_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { connector_zone?: string, connector_id?: string, footprint_zone?: string, connector_name?: string, warehouse_name?: string, warehouse_id?: number }): Promise<{ reasons?: string[] }> 
  {
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/functions/insert_connector_mapping_flow`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

